import {detectElementResizeFunc} from '../modules/detectElementResize';
import {uPopupFunc} from '../modules/uPopup';
import {regAuth} from '../modules/regAuth';
import ready from '../modules/ready';
import {scriptonload} from '../modules/scriptonload';
import {Thetop} from '../modules/Thetop';
import {chooseCity} from '../modules/chooseCity';
import {ChooseCitySwitch} from '../modules/ChooseCitySwitch';
import svg from '../modules/svg';
import Fav from '../modules/Fav';
import Watch from '../modules/Watch';
import AboutFav from '../modules/AboutFav';
import Rating from '../modules/Rating';
import Vote from '../modules/Vote';
import {OpeningUnit} from '../modules/OpeningUnit';
import {Player} from '../modules/Player';
import {CombinedPlayer} from  '../modules/CombinedPlayer';
import {fullscreenGalleryFunc} from  '../modules/fullscreenGallery';
import {NavMonth} from  '../modules/NavMonth';
import {TheaterMap} from  '../modules/TheaterMap';
import {ClubMap} from  '../modules/ClubMap';
import {rightContent} from  '../modules/rightContent';
import {vk} from  '../modules/vk';
import {yt} from  '../modules/yt';
import {fb} from  '../modules/fb';
import {YaShare2} from  '../modules/YaShare2';
import Embeds from  '../modules/Embeds';
import {Comments} from  '../modules/Comments';
import {Avatar} from  '../modules/Avatar';
import {AjaxContent} from  '../modules/AjaxContent' ;
import {MovieList} from  '../modules/MovieList';
import {MovieList2} from  '../modules/MovieList2'; 
import {popupFormSimple} from  '../modules/popupFormSimple';
import {SubContent} from  '../modules/SubContent';
import {showSubContent} from  '../modules/showSubContent';
import {SearchCity} from  '../modules/SearchCity';
import {Tabs} from  '../modules/Tabs';
import {scheme} from  '../modules/scheme';
import {QuizForm} from  '../modules/QuizForm';
import More from  '../modules/More';
import {AllAjax} from  '../modules/AllAjax';
import {banners} from  '../modules/banners';
import {ads} from  '../modules/ads';
import {MyWidgetFilms} from  '../modules/MyWidgetFilms';
import {mainLogo} from  '../modules/mainLogo';
import {notificationPopup} from  '../modules/notificationPopup';
import {disableHover} from '../modules/disableHover';
import {clipboardData} from '../modules/clipboardData';
import {SearchMain} from '../modules/SearchMain';
import {Accordion} from '../modules/Accordion';
import {Title} from '../modules/Title';
import {ToBuy} from  '../modules/ToBuy';
import {cat} from  '../modules/cat';
import {header} from  '../modules/header';
import {CommentsForm} from '../modules/CommentsForm';
import {CommentsItem} from '../modules/CommentsItem';
import {PremiereReminder} from '../modules/PremiereReminder';
import {buyTicketsPopup} from '../modules/buyTicketsPopup';
import {Trailer} from '../modules/Trailer';
import {UPlayerWrapper} from '../modules/UPlayerWrapper';
import {RegAuthBtn} from  '../modules/RegAuthBtn';
import {PageForm} from  '../modules/PageForm';
import {ScrollSlider} from  '../modules/ScrollSlider';
import {ScrollTo} from  '../modules/ScrollTo';
import {ScrollSmooth} from  '../modules/ScrollSmooth';
import {novelties} from  '../modules/novelties';
import {bcontentForm} from  '../modules/bcontentForm';
import {raskhlop} from  '../modules/raskhlop';
import {cityMap} from  '../modules/cityMap';
import {ReloadForm} from  '../modules/ReloadForm';
import {filterRange} from  '../modules/filterRange';
import {filterSchedule} from  '../modules/filterSchedule';
import {nearFilter} from '../modules/nearFilter';
import {geography} from '../modules/geography';
import {onlinePlayer} from '../modules/onlinePlayer';
import {fixSelect} from '../modules/fixSelect';
import VoteResults from '../modules/VoteResults';
import {dynamicIframe} from '../modules/dynamicIframe';
import {bbutton} from '../modules/bbutton';
import {codeInsert} from '../modules/codeInsert';
import {kinoafisha2} from '../modules/kinoafisha2';
import {ratingBlock} from '../modules/ratingBlock';
import {reloadingIframe} from '../modules/reloadingIframe';
import {helpers} from '../modules/helpers';
import {showPopup} from  '../modules/showPopup'; 
import {poll} from  '../modules/poll';
import {thumbGallery} from  '../modules/thumbGallery';
import {userAgent} from  '../modules/userAgent';
import {dynamicPage} from  '../modules/dynamicPage';
import {sticky} from  '../modules/sticky';
import {show} from  '../modules/show';
import {pageBtn} from  '../modules/pageBtn';
import {xhrForm} from  '../modules/xhrForm';
import {clamp} from  '../modules/clamp';
import {multiRange} from  '../modules/multiRange';
import SeriesGallery from '../modules/SeriesGallery';
import seriesSwitch from '../modules/seriesSwitch';

detectElementResizeFunc();
uPopupFunc(window, document);
var fullscreenGallery = fullscreenGalleryFunc(window, document); /* TODO */
kinoafisha2();

APP.objects = {
    /* comeToFavPopup: undefined*/
};

APP.vars.topPadding = 170;

APP.pages = {}

if(APP.vars.isDev){
    APP.pagesParam = { 
        'support': {'ajax':'/_src/layouts/pageModule/support/'},
        'howFav': {'ajax':'/_src/layouts/pageModule/howFav/'},
        'mistake': {'ajax':'/_src/layouts/pageModule/descMistake/'},
        'newMail': {'ajax':''}, //TODO
        'changePwd': {'ajax':'/_src/layouts/pageModule/changePwd/'},
        'subscribe': {'ajax':'/_src/layouts/pageModule/subscribe/'},
        'marvell': {'ajax':'/_src/layouts/pageModule/marvelldd/', "cls":"popup-middle popup-socialMarvell"},
        'allcafe': {'ajax':'/_src/layouts/pageModule/allcafe/?cinema=[CINEMAID]'}
    }
} else {
    APP.pagesParam = {
        'support': {'ajax':'/service/popup/feedback/'},
        'howFav': {'ajax':'/service/popup/howfav/'},
        'mistake': {'ajax':'/service/popup/mistake/'},
        'newMail': {'ajax':'/service/popup/newmail/'},
        'changePwd': {'ajax':'/service/popup/changepwd/'},
        'subscribe': {'ajax':'/service/popup/subscribe/'},
        'allcafe': {'ajax':'/service/popup/allcafe/?cinema=[CINEMAID]'}
    }
}

APP.helpers = helpers();
APP.userAgent = userAgent();


APP.modules = {
    actions: {
        Player: function(el){new Player(el)},
        CombinedPlayer: function(el){new CombinedPlayer(el)},
        fullscreenGallery: function(el){fullscreenGallery(el)},
        NavMonth: function(el){new NavMonth(el)},
        TheaterMap: function(el){
            var initMap = function(){
                    ymaps.ready(createMap);
                },
                createMap = function() {
                    new TheaterMap(el);
                };
            scriptonload(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], initMap);
        },
        ClubMap: function(el){
            var initMap = function(){
                    ymaps.ready(createMap);
                },

                createMap = function(){
                    new ClubMap(el);
                };
            scriptonload(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], initMap);
        },
        rightContent: function(el){rightContent(el)},
        vk: function(el){vk(el)},
        yt: function(el){yt(el)},
        fb: function(el){fb(el)},
        showPopup: function(el){showPopup(el)},
        Avatar: function(el){
            scriptonload('//yandex.st/jquery/2.0.3/jquery.min.js', function(){
                scriptonload('/static/js/vendors/jquery.Jcrop.min.js', function(){
                    new Avatar(el);
                });
            });
        },
        AjaxContent: function(el){new AjaxContent(el)},
        uidatepicker: function(el){
            var init = function(){
                    $.datepicker.regional['ru'] = {
                        closeText: 'Закрыть',
                        prevText: '&#x3c;Пред',
                        nextText: 'След&#x3e;',
                        currentText: 'Сегодня',
                        monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь', 'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
                        monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн', 'Июл','Авг','Сен','Окт','Ноя','Дек'],
                        dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
                        dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
                        dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
                        dateFormat: 'yy-mm-dd',
                        firstDay: 1,
                        isRTL: false,
                        showOtherMonths:true,
                        selectOtherMonths:true,
                        changeMonth:true,
                        changeYear: true
                    };
                    $.datepicker.setDefaults($.datepicker.regional['ru']) ;
                    $(el).datepicker({
                        yearRange: ("-100:-5")
                    });
                },
                checkUI = function(){
                    scriptonload('/static/js/vendors/jquery-ui.js', init);
                };

            if(!window.jQuery) scriptonload('/static/js/vendors/jquery-1.12.0.min.js', checkUI);
            else checkUI();
        },
        MovieList: function(el){new MovieList(el)},
        MovieList2: function(el){new MovieList2(el)},
        popupFormSimple: function(el){popupFormSimple(el)},
        SubContent: function(el){if(!APP.objects.SubContent) APP.objects.SubContent = new SubContent(el)},
        showSubContent: function(el){showSubContent(el)},
        Tabs: function(el){new Tabs(el)},
        scheme: function(el){scheme(el)},
        QuizForm: function(el){new QuizForm(el)},
        AllAjax: function(el){return new AllAjax(el)},
        MyWidgetFilms: function(el){new MyWidgetFilms(el)},
        mainLogo: function(el){mainLogo(el)},
        notificationPopup: function(el){notificationPopup(el)},
        disableHover: function(el){disableHover(el)},
        clipboardData: function(el){clipboardData(el)},
        SearchMain: function(el){new SearchMain(el)},
        Accordion: function(el){new Accordion(el)},
        Title: function(el){new Title(el)},
        PageForm: function(el){new PageForm(el)},
        uPopup: function(el){
            var param = JSON.parse(el.getAttribute('data-param'));
            param.content = el;
            uPopup(param);
        },
        ToBuy: function(el){new ToBuy(el)},
        cat: function(el){cat(el)},
        header: function(el){header(el)},
        PremiereReminder: function(el){new PremiereReminder(el)},
        buyTicketsPopup: function(el){new buyTicketsPopup(el)},
        Trailer: function(el){new Trailer(el)},
        ScrollSlider: function(el){return new ScrollSlider(el)},
        ScrollTo: function(el){return new ScrollTo(el)},
        novelties: function(el){novelties(el)},
        bcontentForm: function(el){bcontentForm(el)},
        raskhlop: function(el){raskhlop(el)},
        bcontent: function(el){
            var init = function(){
                var bcontentObj = bcontent(el);
                /*document.getElementById('saveBtn').onclick = function(){
                    var html = bcontentObj.getHTML();
                    alert(html);
                }*/
            };

            scriptonload(APP.vendors.bcontent, init);
        },
        cityMap: function(el){
            cityMap(el, false);
        },
        browserDetect: function(el){browserDetect()},
        nearFilter: function(el){return nearFilter(el)},
        ReloadForm: function(el){return new ReloadForm(el)},
        chooseCity: function(el){return chooseCity(el)},
        geography: function(el){return geography(el)},
        fixSelect: function(el){return fixSelect(el)},
        bbutton: function(el){return bbutton(el)},
        codeInsert: function(el){return codeInsert(el)},
        reloadingIframe: function(el){return reloadingIframe(el)},
        CommentsItem: function(el, data){return new CommentsItem(el, data);},
        CommentsForm: function(el, data){return new CommentsForm(el, data);},
        Comments: function(el){return new Comments(el);},
        Rating: function(el, data){return new Rating(el, data);},
        Fav: function(el, data){return new Fav(el, data);},
        Watch: function(el, data){return new Watch(el, data);},
        Vote: function(el, data){return new Vote(el, data);},
        YaShare2: function(el, data){return new YaShare2(el, data);},
        uPlayer:function(el, data){return new UPlayerWrapper(el, data);},
        More: function(el, data){return new More(el, data);},
        ScrollSmooth: function(el){return new ScrollSmooth(el)},
        filterRange: function(el, data){return new filterRange(el, data);},
        filterSchedule: function(el, data){return new filterSchedule(el, data);},
        ChooseCitySwitch: function(el){return new ChooseCitySwitch(el);},
        SearchCity: function(el){return new SearchCity(el);},
        onlinePlayer: function(el){return onlinePlayer(el);},
        VoteResults: function(el){return new VoteResults(el);},
        ratingBlock: function(el){return ratingBlock(el);},
        dynamicPage: function(el){return dynamicPage(el);},
        thumbGallery: function(el){return thumbGallery(el)},
        poll: function(el){ return poll(el)},
        banners: function(el){ return banners(el)},
        ads: function(el){ return ads(el)},
        dynamicIframe: function(el){return dynamicIframe(el)},
        sticky: function(el){return sticky(el)},
        show: function(el){return show(el)},
        RegAuthBtn: function(el){return new RegAuthBtn(el)},
        pageBtn: function(el){return pageBtn(el)},
        xhrForm: function(el){return xhrForm(el)},
        Embeds: function(el){return new Embeds(el)},
        SeriesGallery: function(el) {return new SeriesGallery(el)},
        seriesSwitch: function(el) {return new seriesSwitch(el)},
        OpeningUnit: function(el){return new OpeningUnit(el)},
        clamp: function(el){return clamp(el)},
        multiRange: function(el){return multiRange(el)}
    },
    run:function(wrapper, attr, data){
        var wrapper = wrapper || document,
            attr = attr || 'data-modules',
            elementAll = wrapper.querySelectorAll('['+ attr +']'),
            moduleAll = {}; /* ключи - названия модулей, значения - сами модули */

        for(var i=0,j=elementAll.length; i<j; i++){
            var el = elementAll[i],
                nameAll = el.getAttribute(attr).split(' ');

            for(var m=0,n=nameAll.length; m<n; m++){
                var name = nameAll[m];

                if(!this.actions[name]){
                    try {console.error('модуль '+ name +' не найден')} catch(e){};
                    continue;
                }

                if(!moduleAll[name]) moduleAll[name] = [];
                moduleAll[name].push(this.actions[name](el, data));
            }
        }
        return moduleAll;
    },
    destroy:function(moduleAll){
        for(var name in moduleAll){
            var arr = moduleAll[name];
            for(var i=0,j=arr.length; i<j; i++){
                var module = arr[i];
                if(module && module.del) module.del();
                else if(module && module.destroy) module.destroy();
            }
        }
    }
};

APP.isLoading = true;

ready(function(){

    APP.header = document.getElementById('header');
    APP.headerHeight = APP.header ? APP.header.getBoundingClientRect().height : 0;

	if(APP.vars.isUserAuth !== 'notNeed' && !window.regAuthObj) window.regAuthObj = regAuth();
    else window.regAuthObj = false;

    if(regAuthObj && regAuthObj.isAuth && /#\!(reg|auth|recover|support)$/.test(window.location.hash)){
        window.location.replace('https://www.kinoafisha.info/profile/settings/');
        return false;
    }

    APP.modules.run();

	//Блок об избранном, справа
	(function(){
		var item = document.querySelector('[data-aboutFav]');
		if(item && item.className.indexOf('js-active') != -1) new AboutFav(item);
	})();

});

svg(
	document,
	document.getElementsByTagName('use'),
	window.requestAnimationFrame || window.setTimeout,
	{},
	/Trident\/[567]\b/.test(navigator.userAgent) || /Edge\/12/.test(navigator.userAgent) || (navigator.userAgent.match(/AppleWebKit\/(\d+)/) || [])[1] < 538
);